var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	26207: {
		fallback: () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <20.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	37212: {
		fallback: () => (Promise.all([__webpack_require__.e(5886), __webpack_require__.e(326)]).then(() => (() => (__webpack_require__(90326))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	82760: {
		fallback: () => (__webpack_require__.e(6109).then(() => (() => (__webpack_require__(56109))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/styled",

	},
	49069: {
		fallback: () => (__webpack_require__.e(7950).then(() => (() => (__webpack_require__(97950))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0 <20.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	78514: {
		fallback: () => (Promise.all([__webpack_require__.e(7015), __webpack_require__.e(9030), __webpack_require__.e(9315), __webpack_require__.e(2366), __webpack_require__.e(2681), __webpack_require__.e(6207)]).then(() => (() => (__webpack_require__(42681))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0 || ^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@rjsf/utils",

	},
	60820: {
		fallback: () => (Promise.all([__webpack_require__.e(7015), __webpack_require__.e(9315), __webpack_require__.e(2366), __webpack_require__.e(4530)]).then(() => (() => (__webpack_require__(24530))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0 || ^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@rjsf/core",

	},
	21780: {
		fallback: () => (Promise.all([__webpack_require__.e(501), __webpack_require__.e(5886), __webpack_require__.e(8591), __webpack_require__.e(7750), __webpack_require__.e(2590), __webpack_require__.e(1177), __webpack_require__.e(4031), __webpack_require__.e(4161), __webpack_require__.e(8773), __webpack_require__.e(1349)]).then(() => (() => (__webpack_require__(11349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=5.0.0 <10.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mui/material",

	},
	19262: {
		fallback: () => (Promise.all([__webpack_require__.e(501), __webpack_require__.e(5886), __webpack_require__.e(8591), __webpack_require__.e(2590), __webpack_require__.e(1177), __webpack_require__.e(4161), __webpack_require__.e(6128), __webpack_require__.e(820)]).then(() => (() => (__webpack_require__(56128))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0 || ^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@rjsf/mui",

	},
	9272: {
		fallback: () => (Promise.all([__webpack_require__.e(7015), __webpack_require__.e(443)]).then(() => (() => (__webpack_require__(40443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.0 || ^6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@rjsf/validator-ajv8",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"820": [
		60820
	],
	"6207": [
		26207
	],
	"7212": [
		37212
	],
	"8034": [
		82760,
		49069
	],
	"8514": [
		78514
	],
	"8576": [
		21780,
		26207
	],
	"8816": [
		19262,
		78514,
		9272
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}